import { render, staticRenderFns } from "./lrDataPanel.vue?vue&type=template&id=4d568964"
import script from "./lrDataPanel.vue?vue&type=script&lang=js"
export * from "./lrDataPanel.vue?vue&type=script&lang=js"
import style0 from "./lrDataPanel.vue?vue&type=style&index=0&id=4d568964&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports